module.exports = __webpack_public_path__ + "c17b985c33137f61b29fdec1b1ec9efb.svg";